import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    private defaultLife = 3000;

    constructor(
        private messageService: MessageService,
        private translate: TranslateService
    ) {}

    success(config?: ToastMessageOptions) {
        this.messageService.add({
            ...config,
            severity: 'success',
            summary: this.translate.instant(config?.summary ?? 'cropmap.common.success'),
            detail: this.translate.instant(config?.detail ?? 'cropmap.common.action_performed_success'),
        });
    }

    error(config?: ToastMessageOptions) {
        this.messageService.add({
            ...config,
            severity: 'error',
            summary: this.translate.instant(config?.summary ?? 'cropmap.common.error'),
            detail: this.translate.instant(config?.detail ?? 'cropmap.common.something_went_wrong'),
        });
    }

    warn(config?: ToastMessageOptions) {
        this.messageService.add({
            ...config,
            severity: 'warn',
            summary: this.translate.instant(config?.summary ?? 'cropmap.common.warning'),
            detail: this.translate.instant(config?.detail ?? 'cropmap.common.something_went_wrong'),
        });
    }

    info(config?: ToastMessageOptions) {
        this.messageService.add({
            ...config,
            severity: 'info',
        });
    }
}
